import { memo as Memo, useState } from 'react';
import { useRouter } from 'next/router';
import algoliasearch from 'algoliasearch/lite';
import { Configure, InstantSearch } from 'react-instantsearch';

//* Components
import Page from 'components/common/Page';
import Container from 'components/common/Container';
import Text from 'components/common/Text';
import Translate from 'components/common/Translate';
import SearchBox from 'components/pages/search/SearchBox';
import Hits from 'components/pages/search/Hits';
import Pagination from 'components/pages/search/Pagination';

//* Styles
import SearchStyle from 'styles/pages/SearchStyle';

//* Algolia client
const algoliaIndexPrefix = process.env.ALGOLIA_INDEX_PREFIX;
const algoliaImagePrefix = process.env.ALGOLIA_IMAGE_PREFIX;
const algoliaClient = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_SECRET);

const Search = Memo(({ pageParams }) => {
	const router = useRouter();
	const { q: queryParam, page: pageParam } = router.query;

	//! States
	const [initialQuery, setInitialQuery] = useState(queryParam);
	const [resultCount, setResultCount] = useState(0);

	const searchClient = {
		...algoliaClient,
		search: async (requests) => {
			const res = await algoliaClient.search(requests);
			const count = res.results.reduce((sum, r) => sum + r.nbHits, 0);
			setResultCount(count);
			return res;
		},
	};

	const handleSearchStateChange = ({ uiState }) => {
		const searchIndexState = uiState[`${algoliaIndexPrefix}_index`];
		const searchQuery = searchIndexState.query || '';
		const searchPage = (searchIndexState.page || 0) + 1;

		console.log({ searchIndexState, searchQuery, searchPage });

		const newQuery = { ...router.query };

		if (searchQuery) {
			newQuery.q = searchQuery;
		} else {
			delete newQuery.q;
		}

		if (searchPage > 1) {
			newQuery.page = searchPage.toString();
		} else {
			delete newQuery.page;
		}

		if (searchQuery !== queryParam || searchPage !== pageParam) {
			router.replace(
				{
					pathname: router.pathname,
					query: newQuery,
				},
				undefined,
				{ shallow: true }
			);

			setInitialQuery(searchQuery);
		}
	};

	const handleClearSearchParam = () => {
		router.replace(
			{
				pathname: router.pathname,
				query: {},
			},
			undefined,
			{ shallow: true }
		);

		setInitialQuery('');
	};

	return (
		<Page
			meta={{
				title: 'Armenia Travel | Search',
				description: 'Armenia Travel | Search',
			}}
			nextSeoProps={{
				noindex: true,
				nofollow: true,
			}}
			hrefLang={false}
			transparentHeader={pageParams.transparentHeader}
		>
			<SearchStyle>
				<Container>
					<Text
						tag='h1'
						text='search'
						className='s-title font-ping-bold h3'
					/>

					<InstantSearch
						searchClient={searchClient}
						indexName={`${algoliaIndexPrefix}_index`}
						onStateChange={handleSearchStateChange}
						initialUiState={{
							[`${algoliaIndexPrefix}_index`]: {
								query: initialQuery,
								page: pageParam,
							},
						}}
					>
						<SearchBox
							initialQuery={initialQuery}
							onClear={handleClearSearchParam}
						/>

						<Text className='font-ping-medium p pXS secondaryColor2 search-result-count'>
							<Translate
								val={'showingNumResults'}
								vars={{ num: resultCount }}
							/>
						</Text>

						<Configure hitsPerPage={12} />

						<Hits imagePrefix={algoliaImagePrefix} />

						<Pagination
							perPage={12}
							totalHits={resultCount}
						/>
					</InstantSearch>
				</Container>
			</SearchStyle>
		</Page>
	);
});

export default Search;
